import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import NProgress from "nprogress";

export const routeList: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    redirect: "/welcome",
    component: () => import("@/layout/home.vue"),
    meta: {
      label: "首页",
    },
    children: [
      {
        path: "/welcome",
        name: "welcome",
        component: () => import("@/pages/welcome/welcome.vue"),
        meta: {
          label: "数据概览",
          icon: "material-symbols-light:home",
        },
      },
      {
        path: "/user",
        name: "user",
        component: () => import("@/pages/user/list.vue"),
        meta: {
          label: "用户",
          icon: "material-symbols-light:home",
          roles: ["superAdmin", "admin"],
        },
      },
      {
        path: "/changePassword",
        name: "changePassword",
        component: () => import("@/pages/user/changePassword.vue"),
        meta: {
          label: "修改密码",
          icon: "material-symbols-light:home",
          hidden: true,
        },
      },
      {
        path: "/mch",
        name: "mch",
        redirect: "/mch/channelAssocia",
        meta: {
          label: "商家中心",
          icon: "material-symbols-light:home",
          roles: ["admin", "user"],
        },
        children: [
          {
            path: "/mch/channelAssocia",
            name: "mchChannelAssocia",
            component: () => import("@/pages/channelAssocia/list.vue"),
            meta: {
              label: "商户管理",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
          },
          {
            path: "/mch/withdraw/bankcard",
            name: "withdrawBankcard",
            component: () => import("@/pages/youZan/withdraw/bankCard.vue"),
            meta: {
              label: "结算卡",
              icon: "material-symbols-light:home",
              roles: ["user", "admin"],
              hidden: true,
            },
          },
          {
            path: "/mch/withdraw/auto/time",
            name: "withdrawAutoTime",
            component: () =>
              import("@/pages/youZan/createAccount/autoWithdrawTime.vue"),
            meta: {
              label: "自动提现时间",
              icon: "material-symbols-light:home",
              roles: ["user", "admin"],
              hidden: true,
            },
          },
          {
            path: "/mch/orderUnite/create",
            name: "orderUniteCreate",
            component: () => import("@/pages/order/create.vue"),
            meta: {
              label: "创建订单",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
              hidden: true,
            },
          },
          {
            path: "/mch/channelAssocia/receiptPayQr/list",
            name: "mchChannelAssociaReceiptPayQrList",
            component: () => import("@/pages/receiptPayQr/list.vue"),
            meta: {
              label: "收款码",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
              hidden: true,
            },
          },
          {
            path: "/mch/createAccount",
            name: "mchCreateAccount",
            component: () => import("@/pages/createAccount/list.vue"),
            meta: {
              label: "进件管理",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
          },

          {
            path: "/mch/createAccount/youZan/add",
            name: "youZanCreateAccountAdd",
            component: () => import("@/pages/youZan/createAccount/add.vue"),
            meta: {
              label: "新增有赞进件",
              icon: "material-symbols-light:home",
              roles: ["user"],
              hidden: true,
            },
          },

          {
            path: "/mch/createAccount/ysepay/add",
            name: "ysepayCreateAccountAdd",
            component: () => import("@/pages/ysepayCreateAccount/add.vue"),
            meta: {
              label: "新增银盛进件",
              icon: "material-symbols-light:home",
              roles: ["user"],
              hidden: true,
            },
          },
          {
            path: "/mch/createAccount/ysepay/edit",
            name: "ysepayCreateAccountEdit",
            component: () => import("@/pages/ysepayCreateAccount/add.vue"),
            meta: {
              label: "修改银盛进件",
              icon: "material-symbols-light:home",
              roles: ["user"],
              hidden: true,
            },
          },
          {
            path: "/mch/withdraw/list/youzan",
            name: "withdrawList",
            component: () => import("@/pages/youZan/withdraw/list.vue"),
            meta: {
              label: "提现记录",
              icon: "material-symbols-light:home",
              roles: ["admin"],
              hidden: true,
            },
          },

          {
            path: "/mch/youZan/createAccount/edit",
            name: "youZanCreateAccountEdit",
            component: () => import("@/pages/youZan/createAccount/add.vue"),
            meta: {
              label: "修改有赞进件",
              icon: "material-symbols-light:home",
              roles: ["user", "admin"],
              hidden: true,
            },
          },
          {
            path: "/mch/withdraw/add/youzan",
            name: "withdrawAdd",
            component: () => import("@/pages/youZan/withdraw/add.vue"),
            meta: {
              label: "发起提现",
              icon: "material-symbols-light:home",
              roles: ["admin"],
              hidden: true,
            },
          },
          {
            path: "/mch/createAccount/selectService",
            name: "mchCreateAccountSelectService",
            component: () => import("@/pages/createAccount/selectService.vue"),
            meta: {
              label: "选择通道服务商",
              icon: "material-symbols-light:home",
              roles: ["user"],
              hidden: true,
            },
          },

          {
            path: "/mch/createAccount/openPay/youZan/list",
            name: "youZanRecordOpenPayList",
            component: () =>
              import("@/pages/youZan/createAccount/openPayList.vue"),
            meta: {
              label: "支付能力列表",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
              hidden: true,
            },
          },
          {
            path: "//mch/createAccount/openPay/youZan",
            name: "youZanRecordOpenPay",
            component: () => import("@/pages/youZan/createAccount/openPay.vue"),
            meta: {
              label: "开通支付能力",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
              hidden: true,
            },
          },
        ],
      },

      {
        path: "/profile",
        name: "profile",
        component: () => import("@/pages/user/profile.vue"),
        meta: {
          label: "个人信息",
          icon: "material-symbols-light:home",
          hidden: true,
        },
      },

      {
        path: "/exchange",
        name: "exchange",
        redirect: "/exchange/data",
        meta: {
          label: "交易中心",
          icon: "material-symbols-light:home",
          roles: ["user", "admin"],
        },
        children: [
          {
            path: "/exchange/data",
            name: "exchangeData",
            redirect: "/exchange/data/order",
            meta: {
              label: "交易数据",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
            children: [
              {
                path: "/exchange/data/order",
                name: "exchangeDataOrder",
                component: () => import("@/pages/order/list.vue"),
                meta: {
                  label: "订单",
                  icon: "material-symbols-light:home",
                  roles: ["admin", "user"],
                },
              },
              {
                path: "/exchange/data/refund",
                name: "exchangeDataRefund",
                component: () => import("@/pages/order/refundList.vue"),
                meta: {
                  label: "退款",
                  icon: "material-symbols-light:home",
                  roles: ["admin", "user"],
                },
              },
            ],
          },
          {
            path: "/exchange/sharing",
            name: "exchangeSharing",
            redirect: "/exchange/data/sharing",
            meta: {
              label: "分账",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
            children: [
              {
                path: "/exchange/sharingPair/list",
                name: "exchangeSharingPairList",
                component: () => import("@/pages/sharePair/list.vue"),
                meta: {
                  label: "分账关系",
                  icon: "material-symbols-light:home",
                  roles: ["user", "admin"],
                },
              },
              {
                path: "/exchange/sharing/create",
                name: "exchangeSharingCreate",
                component: () => import("@/pages/sharing/create.vue"),
                meta: {
                  label: "发起分账",
                  icon: "material-symbols-light:home",
                  roles: ["user"],
                },
              },
              {
                path: "/exchange/sharing/list",
                name: "exchangeSharingList",
                component: () => import("@/pages/sharing/list.vue"),
                meta: {
                  label: "分账记录",
                  icon: "material-symbols-light:home",
                  roles: ["user", "admin"],
                },
              },
              {
                path: "/exchange/sharing/recipient/list",
                name: "exchangeSharingRecipientList",
                component: () =>
                  import("@/pages/youZan/sharing/recipientList.vue"),
                meta: {
                  label: "分账接受方",
                  icon: "material-symbols-light:home",
                  roles: ["user", "admin"],
                  hidden: true,
                },
              },
              {
                path: "/exchange/sharing/recipient/refund/list",
                name: "exchangeSharingRecipientRefundList",
                component: () =>
                  import("@/pages/youZan/sharing/recipientRefundList.vue"),
                meta: {
                  label: "分账接受方回退",
                  icon: "material-symbols-light:home",
                  roles: ["user", "admin"],
                  hidden: true,
                },
              },
            ],
          },
          {
            path: "/exchange/complaint",
            name: "exchangeComplaint",
            component: () => import("@/pages/youzanComplaintAlipay/list.vue"),
            meta: {
              label: "投诉",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
          },
          {
            path: "/exchange/complaint/wechat/history",
            name: "exchangeComplaintWechatHistory",
            component: () =>
              import("@/pages/youZan/complaint/wechat/listHistory.vue"),
            meta: {
              label: "微信协商历史",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
              hidden: true,
            },
          },
          {
            path: "/exchange/complaint/alipay/history",
            name: "exchangeComplaintAlipayHistory",
            component: () =>
              import("@/pages/youzanComplaintAlipayHistory/list.vue"),
            meta: {
              label: "支付宝协商历史",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
              hidden: true,
            },
          },
        ],
      },
      {
        path: "/data",
        name: "data",
        component: () => import("@/pages/stats/index.vue"),
        meta: {
          label: "数据中心",
          icon: "material-symbols-light:home",
          roles: ["admin", "user"],
        },
      },
      {
        path: "/fund",
        name: "fund",
        redirect: "/fund/withdraw",
        meta: {
          label: "资金中心",
          icon: "material-symbols-light:home",
          roles: ["admin"],
        },
        children: [
          {
            path: "/fund/withdraw",
            name: "fundWithdraw",
            meta: {
              label: "提现",
              icon: "material-symbols-light:home",
              roles: ["user", "admin"],
            },
            children: [],
          },
        ],
      },
      {
        path: "/account",
        name: "account",
        redirect: "/account/auth",
        meta: {
          label: "账号中心",
          icon: "material-symbols-light:home",
          roles: ["user", "admin"],
        },
        children: [
          {
            path: "/account/auth",
            name: "accountAuth",
            component: () => import("@/pages/user/accountAuth.vue"),
            meta: {
              label: "商户认证",
              icon: "material-symbols-light:home",
              roles: ["user", "admin"],
            },
          },

          {
            path: "/account/userInfo",
            name: "accountUserInfo",
            component: () => import("@/pages/user/curUserInfo.vue"),
            meta: {
              label: "商户信息",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
          },
          {
            path: "/account/apiInfo",
            name: "accountApiInfo",
            component: () => import("@/pages/user/apiInfo.vue"),
            meta: {
              label: "接口信息",
              icon: "material-symbols-light:home",
              roles: ["user"],
            },
          },
        ],
      },

      {
        path: "/setService",
        name: "setService",
        component: () => import("@/pages/userSanfangService/list.vue"),
        meta: {
          label: "指定服务商",
          icon: "material-symbols-light:home",
          roles: ["admin"],
        },
      },
      {
        path: "/service",
        name: "service",
        redirect: "/service/youzan",
        meta: {
          label: "服务商",
          icon: "material-symbols-light:home",
          roles: ["superAdmin"],
        },
        children: [
          {
            path: "/service/youzan",
            name: "serviceYouzan",
            component: () => import("@/pages/service/youzan/list.vue"),
            meta: {
              label: "有赞",
              icon: "material-symbols-light:home",
              roles: ["user", "superAdmin"],
            },
          },
          {
            path: "/service/ysepay",
            name: "serviceYsepay",
            component: () => import("@/pages/ysepayService/list.vue"),
            meta: {
              label: "银盛",
              icon: "material-symbols-light:home",
              roles: ["user", "superAdmin"],
            },
          },
        ],
      },
      {
        path: "/youZan",
        name: "youZan",
        redirect: "/youZan/createAccount/list",
        meta: {
          label: "有赞",
          icon: "material-symbols-light:home",
          roles: ["user", "admin"],
          hidden: true,
        },
        children: [
          {
            path: "/youZan/createAccount/list",
            name: "youZanCreateAccountList",
            component: () => import("@/pages/youZan/createAccount/list.vue"),
            meta: {
              label: "进件列表",
              icon: "material-symbols-light:home",
              roles: ["user", "admin"],
            },
          },

          {
            path: "/youZan/subMch/list",
            name: "youZanSubMchList",
            component: () => import("@/pages/youZan/subMchList.vue"),
            meta: {
              label: "子商户",
              icon: "material-symbols-light:home",
              roles: ["admin"],
            },
          },
          {
            path: "/youZan/record/list",
            name: "youZanRecordList",
            component: () => import("@/pages/youZan/recordList.vue"),
            meta: {
              label: "账单",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
          },
        ],
      },
      {
        path: "/orderUnite",
        name: "orderUnite",
        meta: {
          label: "订单",
          icon: "material-symbols-light:home",
          roles: ["user", "admin"],
          hidden: true,
        },
        children: [
          {
            path: "/orderUnite/list",
            name: "orderUniteList",
            component: () => import("@/pages/order/list.vue"),
            meta: {
              label: "订单",
              icon: "material-symbols-light:home",
              roles: ["admin", "user"],
            },
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/user/login.vue"),
    meta: {
      label: "登陆",
      icon: "material-symbols-light:add-home",
      hidden: true,
      while: true,
    },
  },
  {
    path: "/regist",
    name: "regist",
    component: () => import("@/pages/user/regist.vue"),
    meta: {
      label: "注册",
      icon: "material-symbols-light:add-home",
      hidden: true,
      white: true,
    },
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: () => import("@/pages/user/forgetPassword.vue"),
    meta: {
      label: "忘记密码",
      icon: "material-symbols-light:add-home",
      hidden: true,
      white: true,
    },
  },
  {
    path: "/serviceTerm",
    name: "serviceTerm",
    component: () => import("@/pages/user/serviceTerm.vue"),
    meta: {
      label: "服务条款",
      white: true,
    },
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("@/pages/user/privacyPolicy.vue"),
    meta: {
      label: "隐私协议",
      white: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "pathMatch",
    redirect: "/404",
    meta: {
      label: "页面不存在",
      hidden: true,
      white: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/pages/error/404.vue"),
    meta: {
      label: "页面不存在",
      hidden: true,
      white: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routeList,
});

// 路由守卫（前置守卫）
router.beforeEach((to, from) => {
  NProgress.start();

  console.log("路由名称-->", from.name, to.name);

  // 判断是否需要登录
  const userStore = useUserStore();
  if (!userStore.isLogin() && to.path != "/login" && !to.meta.white) {
    return "/login";
  }

  // 判断当前页面是否有权限
  const menuRoleList: Array<String> =
    (to.meta?.roleList as Array<String>) ?? [];
  if (menuRoleList.length > 0 && !hasRole(menuRoleList)) {
    return "/403";
  }
});

router.afterEach((to) => {
  NProgress.done();
  document.title = `${to.meta.label} | ${import.meta.env.VITE_WEB_TITLE}`;
  const appStore = useAppStore();
  appStore.curPageTitle = to.meta.label;
});

router.onError((error) => {
  console.error("路由出错: ", error);
});

/**
 * 判断用户的角色列表是否包含菜单的角色列表任一一个
 * @param menuRoleList 菜单的角色列表
 * @returns 用户角色是否包含菜单的角色
 */
export function hasRole(menuRoleList: String[]): Boolean {
  const userStore = useUserStore();
  const userRole = userStore.role;
  return menuRoleList.includes(userRole ?? "");
}

export default router;
